/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomGroupSchema
 */
export interface CustomGroupSchema {
    /**
     * 
     * @type {number}
     * @memberof CustomGroupSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof CustomGroupSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomGroupSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof CustomGroupSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomGroupSchema
     */
    color: string;
}

/**
 * Check if a given object implements the CustomGroupSchema interface.
 */
export function instanceOfCustomGroupSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "color" in value;

    return isInstance;
}

export function CustomGroupSchemaFromJSON(json: any): CustomGroupSchema {
    return CustomGroupSchemaFromJSONTyped(json, false);
}

export function CustomGroupSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomGroupSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'color': json['color'],
    };
}

export function CustomGroupSchemaToJSON(value?: CustomGroupSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'color': value.color,
    };
}

